export const LOADING = 'LOADING'
export const POPULAR_MENU = 'POPULAR_MENU';
export const SPECIAL_MENU = "SPECIAL_MENU";
export const MENU_CATEGORY = "MENU_CATEGORY";
export const ALL_MENU = 'ALL_MENU';
export const ORDER_MENU = 'ORDER_MENU';
export const ITEMS_IN_CART = 'ITEMS_IN_CART';
export const INCREMENT= 'INCREMENT';
export const DECREMENT= 'DECREMENT';
export const ADD_TO_CART = 'ADD_TO_CART';
export const IS_AUTHENTICATED = 'IS_AUTHENTICATED';
export const LOG_OUT='LOG_OUT';
export const CLEAR_CART='CLEAR_CART';
